<template>
  <div class="quota-notice-step">
    <PlateTitle title="保函开立须知" />
    <div
      class="notice-content"
      v-text="normalizedNotice"
    />
    
    <a-checkbox v-model="agreed">
      我已阅读并同意上述保函开立须知
    </a-checkbox>
  </div>
</template>

<script>
import PlateTitle from '@/components/PlateTitle';

const { normalizeDocumentFiles, normalizeNoticeText } = require('../policy');

export default {
  name: 'QuotaNoticeStep',
  components: { PlateTitle },
  props: {
    notice: { type: String, default: '' },
    files: { type: [ Array, Object ], default: () => [] },
  },
  data() {
    return { agreed: false };
  },
  computed: {
    normalizedNotice() {
      return normalizeNoticeText(this.notice);
    },
    safeFiles() {
      return normalizeDocumentFiles(this.files, window.location.origin);
    },
  },
  methods: {
    validate() {
      if (!this.agreed) throw new Error('请阅读并同意保函开立须知');
      return true;
    },
  },
};
</script>

<style lang="less" scoped>
.notice-content {
  min-height: 260px;
  max-height: 420px;
  margin: 24px 0;
  padding: 24px;
  overflow-y: auto;
  border: 1px solid #e5e5e5;
  white-space: pre-wrap;
  word-break: break-word;
}
.notice-files { margin-bottom: 20px; a { margin-right: 12px; } }
</style>
